import { MerchType } from '@api';
import { z } from 'zod';

const venueMerchFormSchema = z.object({
  rate: z.string(),
  contact: z
    .object({
      personId: z.string(),
      companyId: z.string(),
    })
    .nullable(),
  notes: z.string(),
});

type VenueMerchFormSchemaType = typeof venueMerchFormSchema;
export type VenueMerchFormDataType = z.infer<VenueMerchFormSchemaType>;

type UseVenueMerchFormSchemaReturnType = {
  schema: VenueMerchFormSchemaType;
  defaultValues: VenueMerchFormDataType;
};

export const useVenueMerchFormSchema = (
  venueMerch: MerchType
): UseVenueMerchFormSchemaReturnType => {
  const defaultValues: VenueMerchFormDataType = {
    rate: venueMerch.rate ?? '',
    contact: venueMerch.contact,
    notes: venueMerch.notes ?? '',
  };

  return { schema: venueMerchFormSchema, defaultValues };
};
